import { Fragment, useEffect, useState } from "react";

const ScrollToTop = () => {
  const [activeScrollToTop, setActiveScrollToTop] = useState(false);
  useEffect(() => {
    // let scrollPosition = 0;
    const buttonViewControl = () =>{
      if (window.innerWidth < 992) {
        setActiveScrollToTop(true);
      } else {
        setActiveScrollToTop(false);
      }
    }
    buttonViewControl();
    window.addEventListener("resize", buttonViewControl);
    window.addEventListener("scroll", function () {
      // if (window.scrollY > 50 && window.innerWidth < 992) {
      //   setActiveScrollToTop(true);
      // } else {
      //   setActiveScrollToTop(false);
      // }
      // scrollPosition = window.scrollY;
    });
  }, []);
  const scollTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <Fragment>
      {activeScrollToTop && (
        <div className="scroll-to-top" onClick={scollTop}>
          <span className="btb bt-angle-up"></span>
        </div>
      )}
    </Fragment>
  );
};
export default ScrollToTop;
